import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import Tabs from "design/components/toolbar/Tabs";
import PeriodSelector from "components/PeriodSelector";
import SplitView from "design/layouts/SplitView";
import Center from "design/layouts/Center";
import Right from "design/layouts/Right";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import useElement from "backend/hooks/elements/useElement";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import ExportFileSelectionPopUp from "design/components/popups/ExportFileSelectionPopup";
import InitiativeReport from "components/reports/InitiativeReport";
import ExportButton from "design/components/buttons/ExportButton";
import StrategyReport from "components/reports/StrategyReport";
const StrategyToolbar = (props: { selected?: string }) => {
  const { data: root } = useScorecardTopElement("L0");

  const ctx = useAppContext();
  const link = useLink();
  const { data, isLoading } = useElement(ctx.elementId || root?.id);
  const [anchorEl, setAnchorEl] = React.useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [fileType, setFileType] = React.useState<string | null>();
  const [isExporting, setIsExporting] = React.useState<boolean>(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSelectFile = (type: string) => {
    setFileType(type);
    setAnchorEl(null);
    setIsExporting(true);
  };
  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
        <ToolbarTitle>{data ? data.name : ""}</ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || ""}
            options={[
              {
                viewName: "strategymap",
                title: "Strategy Map",
              },
              {
                viewName: "overview",
                title: "Overview",
              },
              {
                viewName: "kpis",
                title: "KPIs",
              },
              {
                viewName: "initiatives",
                title: "Initiatives",
              },
            ]}
          />
        </Center>
        <Right>
          <PeriodSelector level="Month" />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default StrategyToolbar;
